import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Engage = ({ userRole }) => {
  const navigate = useNavigate();

  // Restrict access to Movers and Admins only
  useEffect(() => {
    if (userRole !== 'Mover' && userRole !== 'Admin') {
      navigate('/login', { replace: true });
    }
  }, [userRole, navigate]);

  if (userRole !== 'Mover' && userRole !== 'Admin') {
    return null;
  }

  return (
    <div className="engage-page" style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h2 style={{ fontSize: '24px', color: '#333', marginBottom: '20px' }}>Engage</h2>
      <p style={{ fontSize: '16px', color: '#666' }}>
        This is the Engage page, accessible to Movers and Admins. Add functionality for engagement tasks here.
      </p>
    </div>
  );
};

export default Engage;